import React from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import {FilterLineupsByPlayer} from './index';
import {getModesConfigByActiveMode} from 'helpers/modes-config';

function getF1LineupRoles(sportConfig, activeMode) {
    const rolesMap = {
        '*': ['CPT', 'D', 'CNSTR'],
        CPT: ['CPT'],
        D: ['D'],
        CNSTR: ['CNSTR'],
    };

    return rolesMap[activeMode] ?? [];
}

function getLineupRoles(sportConfig, activeMode) {
    if (sportConfig.isSportF1()) {
        return getF1LineupRoles(sportConfig, activeMode);
    }

    const modesConfig = getModesConfigByActiveMode(sportConfig, activeMode);

    return Object.values(modesConfig).map((modeConfig) => modeConfig.getRole());
}

class FilterLineupsByPlayerAndMode extends FilterLineupsByPlayer {
    onCheck(isChecked) {
        const playerLineupRoles = this.getPlayerLineupRoles();

        if (isEmpty(playerLineupRoles)) {
            return;
        }

        const {player} = this.props;

        this.props.dispatch(
            Action.do('filterLineupsByCheckedPlayer', {
                playerId: player.getId(),
                lineupRoles: playerLineupRoles,
                isChecked,
            }),
        );
    }

    getPlayerLineupRoles() {
        const {player, activeMode = Const.OVERALL_MODE, sportConfig, lineupPlayerMap} = this.props;

        const lineupRoles = getLineupRoles(sportConfig, activeMode);

        const lineups = lineupPlayerMap.getLineupsByPlayerId(player.getId());

        if (isEmpty(lineups)) {
            return [];
        }

        return arrayDuplicates(lineupRoles, Object.keys(lineups));
    }

    isPlayerChecked() {
        const {player, filterLineupsByPlayer} = this.props;

        const playerLineupRoles = this.getPlayerLineupRoles();

        return filterLineupsByPlayer.isPlayerCheckedOnLineupRoles(player.getId(), playerLineupRoles);
    }
}

function mapStatesToProps(state) {
    const {filterLineupsByPlayer, lineupPlayerMap, sportConfig} = state;

    return {
        filterLineupsByPlayer,
        lineupPlayerMap,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(FilterLineupsByPlayerAndMode);
